var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadJobIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 11.418l4.58-4.6v19.18a2 2 0 1 0 4 0V6.818l4.58 4.6a1.999 1.999 0 0 0 2.84 0 2 2 0 0 0 0-2.84l-8-8a2 2 0 0 0-.66-.42 2 2 0 0 0-1.52 0 2 2 0 0 0-.66.42l-8 8a2.008 2.008 0 1 0 2.84 2.84zM38 19.998a2 2 0 0 0-2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-12a2 2 0 0 0-4 0v12a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6v-12a2 2 0 0 0-2-2z",
    fill: "#696871",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadJobIcon);
export default __webpack_public_path__ + "static/media/upload-job-icon.112a634b7a3a17fee258a4bf2cf6a83e.svg";
export { ForwardRef as ReactComponent };